import {
  Stack,
  YStack,
  styled,
  Image,
  Unspaced,
  YStackProps,
} from '@mythical/ui'
import Spinner from 'app/components/primitive/Spinner'
import React from 'react'

type LockModalProps = {
  onUnlock: () => void
  id: string
  loading?: boolean
  children?: React.ReactNode
} & YStackProps

const LockModalWrapper = styled(YStack, {
  zIndex: 100,
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  p: '$4',
})

const LockModalInner = styled(YStack, {
  pos: 'relative',
  ai: 'center',
  jc: 'center',
  maxWidth: 450,
  w: '100%',
  bg: '$secondary10',
  p: '$4',
  borderRadius: '$2',
  borderWidth: 1,
  borderColor: '$primary10',
  space: '$4',
  overflow: 'hidden',
  elevation: 10,
})

const LockModal = ({
  id,
  onUnlock,
  loading,
  children,
  ...props
}: LockModalProps) => {
  return (
    <LockModalWrapper {...props}>
      <LockModalInner>
        <Unspaced>
          <Stack top="$0" left="$0" zIndex="$2" position="absolute">
            <Image
              height={80}
              width={90}
              style={{ width: 90, height: 80 }}
              source={require('app/assets/images/serpent1.png')}
            />
          </Stack>
        </Unspaced>
        <Unspaced>
          <Stack top="$3" right="$0" zIndex="$2" position="absolute">
            <Image
              height={60}
              width={80}
              style={{ width: 80, height: 60 }}
              source={require('app/assets/images/serpent2.png')}
            />
          </Stack>
        </Unspaced>
        <Unspaced>
          <Stack
            bottom="$1"
            right="$-7"
            zIndex="$2"
            $gtXs={{
              right: '$0',
            }}
            position="absolute"
          >
            <Image
              height={50}
              width={90}
              style={{ width: 90, height: 50 }}
              source={require('app/assets/images/serpent3.png')}
            />
          </Stack>
        </Unspaced>
        <Unspaced>
          <Stack
            bottom="$-3"
            left="$-7"
            zIndex="$2"
            $gtXs={{
              left: '$0',
            }}
            position="absolute"
          >
            <Image
              height={60}
              width={90}
              style={{ width: 90, height: 60 }}
              source={require('app/assets/images/serpent4.png')}
            />
          </Stack>
        </Unspaced>
        {loading && (
          <Unspaced>
            <Stack py="$12">
              <Spinner size="large" scale={1.5} />
            </Stack>
          </Unspaced>
        )}
        {!loading && children}
      </LockModalInner>
    </LockModalWrapper>
  )
}

export default LockModal
